module.exports = __webpack_public_path__ + "img/logo@2x.e28cacb8.png";